// 微信支付方法（点击按键调用）
// let wx = require('http://res.wx.qq.com/open/js/jweixin-1.2.0.js');
var wx = window.wx
/*
微信支付方法
获取微信加签信息
@param{data}:获取的微信加签
@param{cb}:成功回调
*/
let wexinPay = (data, cb, errorCb = null, completeCb = null, cancelCb = null) => {
  // const _this = this
  WeixinJSBridge.invoke('getBrandWCPayRequest', {
    'appId': data.config.appId, // 公众号ID，由商户传入
    'timeStamp': data.config.timeStamp, // 时间戳，自1970年以来的秒数
    'nonceStr': data.config.nonceStr, // 随机串
    'package': data.config.packageValue,
    'signType': data.config.signType, // 微信签名方式
    'paySign': data.config.paySign // 微信签名
  },
  function (res) {
    if (res.err_msg == 'get_brand_wcpay_request:ok') {
      cb()
      console.log('成功')
    } else {
      console.log('支付失败，请重新尝试！')
    }
  })
}
export default wexinPay



// WEBPACK FOOTER //
// ./src/utils/weixinpay.js